import { FC } from "react"
import { COLORS } from "shared/consts"

type UnionIconProps = {
  fill?: string;
}
export const UnionIcon: FC<UnionIconProps> = ({
  fill = COLORS.FG.DEFAULT
}) => {
  return (
    <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5 4.58333H6.25V3.33333V1.25H10.4167V3.33333V4.58333H11.6667H13.2322L8.33333 9.48223L3.43443 4.58333H5ZM5 0.833333V2.08333V3.33333H3.75H2.42851C1.68609 3.33333 1.31429 4.23095 1.83926 4.75592L7.74408 10.6607C8.06952 10.9862 8.59715 10.9862 8.92259 10.6607L14.8274 4.75592C15.3524 4.23095 14.9806 3.33333 14.2382 3.33333H12.9167H11.6667V2.08333V0.833333C11.6667 0.373096 11.2936 0 10.8333 0H5.83333C5.3731 0 5 0.373096 5 0.833333ZM0 13.3333V10.8333H1.25V13.3333C1.25 13.5635 1.43655 13.75 1.66667 13.75H15C15.2301 13.75 15.4167 13.5635 15.4167 13.3333V10.8333H16.6667V13.3333C16.6667 14.2538 15.9205 15 15 15H1.66667C0.746193 15 0 14.2538 0 13.3333Z" fill={fill}/>
    </svg>
  )
}